import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  flex: 1;
`;

export const ContentPadding = styled.View`
  padding: 0 ${RFValue(24)}px;
`;

export const SuccessBanner = styled.View`
  background-color: ${({theme}) => theme.colors.success_bg};
  padding: ${RFValue(16)}px ${RFValue(24)}px ${RFValue(40)}px;
  align-items: center;
`;

export const BackButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(16)}px;
  left: ${RFValue(16)}px;
  padding: ${RFValue(4)}px;
  z-index: 2;
`;

export const BackIcon = styled(Feather)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const SuccessIconWrapper = styled.View`
  background-color: ${({theme}) => theme.colors.price_card};
  width: ${RFValue(56)}px;
  height: ${RFValue(56)}px;
  border-radius: ${RFValue(16)}px;
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(12)}px;
  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.12;
  shadow-radius: 10px;
  elevation: 4;
`;

export const SuccessIcon = styled(Feather)`
  font-size: ${RFValue(28)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const BannerTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const BannerSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  text-align: center;
  line-height: ${RFValue(18)}px;
`;

export const SummaryCard = styled.View`
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(16)}px;
  margin: -${RFValue(24)}px ${RFValue(24)}px ${RFValue(16)}px;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.08;
  shadow-radius: 6px;
  elevation: 3;
`;

export const SummaryRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${RFValue(6)}px;
`;

export const SummaryLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const SummaryValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const SectionTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  margin: ${RFValue(8)}px ${RFValue(24)}px ${RFValue(12)}px;
`;

export const OptionCard = styled.TouchableOpacity<{selected: boolean}>`
  background-color: ${({theme}) => theme.colors.price_card};
  border-width: 2px;
  border-color: ${({theme, selected}) =>
    selected ? theme.colors.primary : theme.colors.border};
  border-radius: ${RFValue(14)}px;
  padding: ${RFValue(14)}px ${RFValue(16)}px;
  margin: 0 ${RFValue(24)}px ${RFValue(10)}px;
`;

export const OptionHeader = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${RFValue(6)}px;
`;

export const OptionInstallments = styled.Text<{selected: boolean}>`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(15)}px;
  color: ${({theme, selected}) =>
    selected ? theme.colors.primary : theme.colors.title};
`;

export const OptionTotal = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const OptionDetail = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${RFValue(2)}px;
`;

export const OptionDetailLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const OptionDetailValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const RadioOuter = styled.View<{selected: boolean}>`
  width: ${RFValue(20)}px;
  height: ${RFValue(20)}px;
  border-radius: ${RFValue(10)}px;
  border-width: 2px;
  border-color: ${({theme, selected}) =>
    selected ? theme.colors.primary : theme.colors.border};
  align-items: center;
  justify-content: center;
`;

export const RadioInner = styled.View`
  width: ${RFValue(10)}px;
  height: ${RFValue(10)}px;
  border-radius: ${RFValue(5)}px;
  background-color: ${({theme}) => theme.colors.primary};
`;

export const Divider = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border};
  margin: ${RFValue(4)}px 0;
`;

export const Footer = styled.View`
  padding: ${RFValue(12)}px ${RFValue(24)}px ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.background};
`;

export const DisclaimerText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(9)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  margin-bottom: ${RFValue(8)}px;
  line-height: ${RFValue(14)}px;
  padding: 0 24px;
`;
